import { apiClient } from './authenticatedApiClient';
import { AppSingletonPromise } from './AppSingletonPromise';
import { IBericht } from '@/model/IBericht';

class AppBerichtenService {
  @AppSingletonPromise
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public getBerichten(force = false): Promise<IBericht[]> {
    return apiClient.get<IBericht[]>('Berichten').then(response => {
      return response.data.map(d => Object.assign(d, { read: false }));
    });
  }

  public markAsRead(berichtId: string): Promise<void> {
    return apiClient.put(`Berichten/${berichtId}/true`);
  }
}

export const appBerichtenService = new AppBerichtenService();
